module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/011-zimbabwe-83d38a9ba8cbb4b7df7d9fb3c3ccf7ee.svg";